<template>
  <base-modal
    :title="'The following assets have references:'"
    @close-modal="onCloseModal"
  >
    <div class="wrapper">
      <ul>
        <li v-for="item in assets" :key="item.id">
          <div class="thumb">
            <svg-icon
              v-if="item.type === 'audio'"
              icon="app-icons/audio-start"
              width="28"
              height="28"
              fill="#FFFFFF"
            />
            <img
              v-else-if="getSmallImageUrl(item.id)"
              width="64"
              height="64"
              :src="getSmallImageUrl(item.id)"
            />
          </div>
          <div class="name">
            {{
              item.name +
              (getExtension(item.id) ? '.' + getExtension(item.id) : '')
            }}
          </div>
        </li>
      </ul>
      <p>
        Are you sure you want to delete them and remove all of their references?
      </p>
      <div class="buttons">
        <div class="button confirm" @click="onConfirm">Yes, delete</div>
        <div class="button cancel" @click="onCloseModal">Cancel</div>
      </div>
    </div>
  </base-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';
import BaseModal from './BaseModal.vue';

export default {
  components: {
    BaseModal,
    SvgIcon,
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters('application/modals', ['getDeleteAssetReferencesModal']),
    ...mapGetters('project/data/assets', [
      'getExtension',
      'getNode',
      'getNodes',
      'getDescendantNodes',
      'getSmallImageUrl',
    ]),
    ...mapGetters('project/data/components', {
      getAssetComponentReferences: 'getAssetReferences',
    }),
    ...mapGetters('project/data/elements', {
      getAssetElementReferences: 'getAssetReferences',
    }),

    /**
     * Returns the to be deleted asset id
     * @returns {String}
     */
    assetId() {
      return this.getDeleteAssetReferencesModal;
    },

    /**
     * Returns the asset
     * @returns {Object}
     */
    asset() {
      return this.getNode(this.assetId);
    },

    /**
     * Returns the asset
     * @returns {Object}
     */
    assets() {
      return this.getNodes(this.assetIds);
    },

    /**
     * Return the small image url for the asset
     * @returns {String|null}
     */
    imageUrl(id) {
      return this.getTinyImageUrl(id);
    },

    /**
     * Returns the ids of components & elements referencing this asset
     * @returns {Array}
     */
    assetIds() {
      const assetIds = this.getDescendantNodes(
        this.assetId,
        'assets',
        'children'
      );
      assetIds.push(this.assetId);
      const componentIds = Object.keys(
        this.getAssetComponentReferences(assetIds)
      );
      const elementIds = Object.keys(this.getAssetElementReferences(assetIds));
      return [...new Set([...componentIds, ...elementIds])];
    },
  },

  methods: {
    ...mapActions('application/modals', ['setDeleteAssetReferencesModal']),
    ...mapActions('project/data/assets', ['deleteAsset']),

    onConfirm() {
      this.deleteAsset({
        id: this.assetId,
        apply: true,
      });

      this.setDeleteAssetReferencesModal({
        value: null,
      });
    },

    onCloseModal() {
      this.setDeleteAssetReferencesModal({
        value: null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 20px 20px;
  ul {
    padding: 0;
    margin: 20px 0 0 0;
    li {
      list-style: none;
      display: flex;
      align-items: center;
      margin: 0 0 20px 0;
      .name {
        font-size: 15px;
        color: #fff;
        font-size: 15px;
      }
      .thumb {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        margin: 0 10px 0 0;
        border-radius: 3px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  .button {
    padding: 8px 12px;
    border-radius: 3px;
    display: inline-block;
    color: #fff;
    cursor: pointer;
    margin: 10px 0 0 20px;

    &.confirm {
      background: #ab1f1f;
      border: none;

      &:hover {
        background: #d02020;
      }
    }

    &.cancel {
      border: 1px solid #6e797b;
      background: #2c3233;

      &:hover {
        background: #464b4c;
      }
    }
  }
}
</style>
